if (!customElements.get('product-list-form')) {
    customElements.define('product-list-form', class ProductListForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartCounter = document.getElementById('cart-counter');
        this.cartCounterMobile = document.getElementById('cart-counter-mobile');
      }
  
      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;
  
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections_url', window.location.pathname);
        const size = formData.get('Size');
        const quantity = formData.get('quantity');
        const id = formData.get('id');
        config.body = {
          id,
          quantity,
          properties: {
            size
          }
        };
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            fetch(`${routes.cart_url}`, fetchConfig('javascript'))
              .then(r => r.json())
              .then(d => {
                this.cartCounter.innerText = d.item_count;
                this.cartCounterMobile.innerText = d.item_count;
              })
              .catch(e => console.log(e));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    });
  }